import React from 'react';
// Framer Motion supprimé - utilisation d'animations CSS
import { User } from 'lucide-react';

const Avatar = ({ 
  src, 
  alt, 
  name, 
  size = 'md', 
  className = '',
  showFallback = true,
  isOnline = false,
  showOnlineStatus = true
}) => {
  
  const sizeClasses = {
    xs: 'h-6 w-6 text-xs',
    sm: 'h-8 w-8 text-sm',
    md: 'h-10 w-10 text-base',
    lg: 'h-12 w-12 text-lg',
    xl: 'h-16 w-16 text-xl',
    '2xl': 'h-20 w-20 text-2xl'
  };

  const getInitials = (name) => {
    if (!name) return '?';
    return name
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const getBackgroundColor = (name) => {
    if (!name) return 'bg-gray-400';
    
    const colors = [
      'bg-blue-500',
      'bg-green-500', 
      'bg-purple-500',
      'bg-pink-500',
      'bg-indigo-500',
      'bg-yellow-500',
      'bg-red-500',
      'bg-teal-500'
    ];
    
    const hash = name.split('').reduce((a, b) => {
      a = ((a << 5) - a) + b.charCodeAt(0);
      return a & a;
    }, 0);
    
    return colors[Math.abs(hash) % colors.length];
  };

  // Définir la taille du badge de statut en ligne
  const badgeSize = {
    xs: 'h-2 w-2',
    sm: 'h-2.5 w-2.5',
    md: 'h-3 w-3',
    lg: 'h-4 w-4',
    xl: 'h-5 w-5',
    '2xl': 'h-6 w-6'
  };

  // Toujours utiliser les avatars avec initiales pour les médecins
  return (
    <div className="relative inline-block">
      <div
        className={`
          ${sizeClasses[size]} 
          ${getBackgroundColor(name)}
          rounded-full 
          flex 
          items-center 
          justify-center 
          text-white 
          font-semibold 
          ${className}
        `}
        title={alt || name}
      >
        {name ? getInitials(name) : <User className="h-1/2 w-1/2" />}
      </div>
      
      {showOnlineStatus && (
        <span
          className={`
            absolute 
            bottom-0 
            right-0 
            ${badgeSize[size]}
            ${isOnline ? 'bg-green-500' : 'bg-gray-400'}
            border-2 
            border-white 
            rounded-full
            ${isOnline ? 'animate-pulse' : ''}
          `}
          title={isOnline ? 'En ligne' : 'Hors ligne'}
        />
      )}
    </div>
  );
};

export default Avatar;
